const resourceNames = {
  activitySurvey: 'Activity Survey',
  auth: 'Connected Account',
  authUsage: 'Connected Account Usage',
  authTest: 'Connected Account Test',
  capabilities: 'Capabilities',
  devAppEvents: 'App Events',
  devAppEventStats: 'App Event Stats',
  devAppIssueActionTag: 'App Issue Tag',
  devAppIssues: 'App Issues',
  devAppIssueTag: 'App Issue Tag',
  devAppLokiTags: 'Issue Tags',
  dropdown: 'Dropdown Choices',
  fieldErrors: 'Field Validation',
  fileUpload: 'File',
  folder: 'Folder',
  folders: 'Folders',
  givesAll: 'Insert Fields',
  heldReasons: 'Zap Held Reasons',
  needs: 'Fields',
  node: 'Node',
  nodes: 'Nodes',
  nodeSample: 'Sample',
  nodeSubscription: 'Webhook Subscription',
  search: 'Search Results',
  sharedZap: 'Template',
  supportRequest: 'Support Request',
  service: 'service',
  services: 'services',
  taskReplay: 'Task Replay',
  taskStates: 'Task States',
  task: 'Task',
  tasks: 'Tasks',
  zap: 'Zap',
  zapAction: 'Zap Action',
  zapDelete: 'Zap Delete',
  zapNotes: 'Zap Notes',
  zapRun: 'Zap Run',
  zapRunStatus: 'Zap Run Status',
  zaps: 'Zaps',
  zapTemplates: 'Zap templates',
  zapTrigger: 'Zap Trigger',
};

export default resourceNames;
